import { createId } from '../utils/ids.js';

function point(value) {
  return [Number(value?.[0]) || 0, Number(value?.[1]) || 0];
}

export class MeasurementManager {
  static distance(start, end) {
    const a = point(start);
    const b = point(end);
    return Math.hypot(b[0] - a[0], b[1] - a[1]);
  }

  static formatDistance(distance, units = 'metric') {
    const value = Math.max(0, Number(distance) || 0);
    if (units === 'imperial') {
      const totalInches = value * 39.3701;
      const feet = Math.floor(totalInches / 12);
      const inches = Math.round(totalInches - feet * 12);
      return `${feet}′ ${inches}″`;
    }
    return `${value.toFixed(value < 10 ? 2 : 1)} m`;
  }

  static polygonArea(polygon) {
    if (!Array.isArray(polygon) || polygon.length < 3) return 0;
    let area = 0;
    for (let index = 0; index < polygon.length; index += 1) {
      const current = point(polygon[index]);
      const next = point(polygon[(index + 1) % polygon.length]);
      area += current[0] * next[1] - next[0] * current[1];
    }
    return Math.abs(area) / 2;
  }

  static create(start, end, floorId, units = 'metric') {
    const safeStart = point(start);
    const safeEnd = point(end);
    const distance = this.distance(safeStart, safeEnd);
    return {
      id: createId('measurement'),
      name: `Measurement ${this.formatDistance(distance, units)}`,
      type: 'measurement',
      start: safeStart,
      end: safeEnd,
      distance,
      units,
      floorId,
      visible: true,
      locked: false
    };
  }
}

